import { LIST_LANGUAGE_ENUM } from "./constants";

export const I18N_FALLBACK_LNG = [LIST_LANGUAGE_ENUM.EN];
export const I18N_WHITELIST = [
    LIST_LANGUAGE_ENUM.EN,
    LIST_LANGUAGE_ENUM.ZHHK,
    LIST_LANGUAGE_ENUM.ZHTW,
    LIST_LANGUAGE_ENUM.JA,
];
